import { get, post } from '@/utils/request1';
export const facilitatorList = (data) => post('orderw/splist',data); // 服务商列表